import { render, staticRenderFns } from "./CervicogenicHeadaches.vue?vue&type=template&id=4aa068ae&scoped=true"
import script from "./CervicogenicHeadaches.vue?vue&type=script&lang=js"
export * from "./CervicogenicHeadaches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa068ae",
  null
  
)

export default component.exports